<template>
  <app-pricing />
</template>
<script>
import AppPricing from '@/components/app-pricing/AppPricing.vue'
export default {
  name: 'AppPricingView',
  components: {
    AppPricing
  }
}
</script>
<style lang="scss" scoped></style>
